import type { ReactNode } from 'react';
import { Box } from '@mui/material';

/** Shared geometry and title rhythm for every routed application page. */
export function PageSurface({ children, embedded = false }: { children: ReactNode; embedded?: boolean }) {
  return (
    <Box
      className="ResponseDockPageSurface"
      sx={{
        width: '100%',
        maxWidth: 1280,
        mx: 'auto',
        minWidth: 0,
        '& > .MuiBox-root': {
          width: '100%',
          maxWidth: 'none !important',
          marginLeft: '0 !important',
          marginRight: '0 !important',
        },
        '& > .MuiBox-root > :first-child .MuiTypography-h4, & > .MuiBox-root > :first-child .MuiTypography-h5': {
          fontSize: { xs: '1.35rem', sm: '1.5rem' },
          lineHeight: 1.25,
          fontWeight: '800 !important',
          letterSpacing: '-0.02em',
        },
        '& > .MuiBox-root > :first-child .MuiTypography-body1, & > .MuiBox-root > :first-child .MuiTypography-body2': {
          lineHeight: 1.6,
        },
        ...(embedded ? { maxWidth: 1280 } : {}),
      }}
    >
      {children}
    </Box>
  );
}
